import React from 'react'
import Slider from 'react-slick'

import './BoxSlider.css'

const settings = {
  dots: true,
  customPaging: i => {
    return <span className="fmbm-box-slider__slide" />
  },
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 4,
  variableWidth: true,
  autoplay: true,
  responsive: [
    {
      breakpoint: 500,
      settings: {
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToScroll: 3,
      },
    },
  ],
}

export const BoxSlider = ({ items, style }) => {
  return (
    <div className="fmbm-box-slider">
      <Slider {...settings}>
        {items.map((item, index) => (
          <div key={index}>
            <div className="fmbm-box-slider__item" style={item.style}>
              <div className="fmbm-box-slider__item-icon">
                <img src={item.icon} alt="" />
              </div>
              <div className="fmbm-box-slider__item-text">{item.text}</div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default BoxSlider



// WEBPACK FOOTER //
// ./src/Components/BoxSlider/BoxSlider.js